var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"switch",class:{active: _vm.active},on:{"click":_vm.toggle}})])}
var staticRenderFns = []

export { render, staticRenderFns }